import { Box, Paper, Stack } from '@mui/material'
import AppearanceThemePicker from '@/components/Settings/AppearanceThemePicker'
import appearanceStyles from '@/components/Settings/AppearanceSettingsContent.module.scss'
import { SettingsRowLabelBlock } from '@/components/Settings/settingsRowLabelBlock'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import shared from '@/components/Settings/settingsShared.module.scss'

/** @param {{ headingId: string, paperSingle: string, appearanceMode: string, onAppearanceModeChange: (v: string) => void }} props */
export function AppearanceModeSection({ headingId, paperSingle, appearanceMode, onAppearanceModeChange }) {
  return (
    <Stack component="section" spacing={1.25} className={shared.preferenceSection} aria-labelledby={headingId}>
      <SettingsSectionIntro headingId={headingId} lines={getSettingsSectionIntro('appearance')} />
      <Paper elevation={0} className={paperSingle}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" className={appearanceStyles.appearanceRow}>
          <SettingsRowLabelBlock title="Appearance" hideDescription />
          <Box className={appearanceStyles.appearanceRowControls}>
            <AppearanceThemePicker value={appearanceMode} onChange={onAppearanceModeChange} />
          </Box>
        </Stack>
      </Paper>
    </Stack>
  )
}
